import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../../services/data.service';
import { IceapiService } from '../../../../services/index';
import { CalculationType } from '../../enums/calculation-type.enum';
import { TighteningMethod } from '../../enums/tightening-method.enum';
import { DiagramDataModel, DiagramInfo, DimensionOverridesInput, ProcessInfoData, StdInputData, TighteningData } from '../../models';
import { CalculationResult, InputGroup, ToolOutput } from '../../models/calculationModels/index';
import { ControlData } from '../../models/control-data';
import { ProcessInfoModel } from '../../models/process-info-model';
import { SubHeaderData } from '../../models/sub-header-data';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'app-standard-flange',
    templateUrl: './standard-flange.component.html',
    styleUrls: ['./standard-flange.component.scss'],
    standalone: false
})
export class StandardFlangeComponent implements OnInit, OnDestroy {
    @Input() cssClass;
    @ViewChild('panel1') panel1;
    @ViewChild('panel2') panel2;
    @ViewChild('panel3') panel3;
    @ViewChild('panel4') panel4;
    @ViewChild('beginbtn', { static: false }) beginbtn: ElementRef;
    destroy$ = new Subject();

    subHeaderData: SubHeaderData;
    stdFlangeInput: InputGroup;
    calculationResult: CalculationResult;
    toolsData: ToolOutput[];
    processInfoInput: ProcessInfoModel;
    diagramInfo: DiagramDataModel;
    outputTabIndex = 0;
    selectedTool: ToolOutput;
    isInitialFormLoad: boolean = true;
    isInputValid: boolean = false;
    isTighteningInputValid: boolean = false;
    isStdInputValid: boolean = false;
    isProcessInfoInputValid: boolean = false;
    tooltip_position = 'above';
    tighteningform = false;
    stdInputform = false;
    processform = false;
    toolsform = false;
    showpaneltoggle = false;
    showPanelUnitToggle = false;
    editpanel_1 = false;
    editpanel_2 = false;
    editpanel_3 = false;
    editpanel_4 = false;
    hideAdvanceOptionTab: boolean = false;
    isRedirect: string = 'false';
    processInfoForm: UntypedFormGroup;
    standardInputForm: UntypedFormGroup;
    tighteningProcedureForm: UntypedFormGroup;
    toolsFormGroup: UntypedFormGroup;
    LoadCalculationSubscription: Subscription;
    isOverriddenFlange: boolean;
    IsCalculationOutPutTabSelected: boolean = false;
    isCalculationDone: boolean;
    istighFormValid: boolean = false;
    isStdFormValid: boolean = false;
    isProcessFormValid: boolean = false;

    constructor(
        private iceapi: IceapiService,
        private renderer: Renderer2,
        private route: ActivatedRoute,
        private dataSvc: DataService,
        private router: Router,
        private cd: ChangeDetectorRef,
        private ngxUiLoaderService: NgxUiLoaderService,
        private globalEmittersService: GlobalEmittersService,
        private user_utility: UserUtilityService,
                         private translocoService: TranslocoService
    ) {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.isOverriddenFlange = false;
    }

    ngOnInit() {
        this.subHeaderData = this.setSubHeaderValues(false);
        this.stdFlangeInput = new InputGroup();
        this.diagramInfo = new DiagramDataModel();

        this.route.params.subscribe((params) => {
            this.isRedirect = params['isRedirect'];
        });
        if (this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            this.calculationResult = this.dataSvc?.calculationData;
            this.stdFlangeInput = this.dataSvc?.calculationData?.input;
            this.toolsData = this.dataSvc?.calculationData?.output?.tools;
            this.isInitialFormLoad = false;
            this.editpanel_1 = true;
            this.editpanel_2 = true;
            this.editpanel_3 = true;
            this.editpanel_4 = true;
            this.tighteningform = true;
            this.stdInputform = true;
            this.processform = true;
            this.toolsform = true;
            this.ngxUiLoaderService.stop();
            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning

            this.isCalculationDone = true;
        } else {
            this.stdFlangeInput = new InputGroup();
            this.dataSvc.calculationData = null;
            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
        }

        this.globalEmittersService.currentCalculationType.next(CalculationType.StandardFlange);

        this.globalEmittersService.openControlProcedurePanel.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.showPanel1And2();
            }
        });

        this.globalEmittersService.processInfoForm.pipe(takeUntil(this.destroy$)).subscribe((res: UntypedFormGroup) => {
            this.processInfoForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isProcessFormValid = false;
                }
            });
        });

        this.globalEmittersService.standardInputForm.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.standardInputForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.isStdFormValid = false;
                }
            });
        });

        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((res: UntypedFormGroup) => {
            this.tighteningProcedureForm = res;
            res?.valueChanges?.pipe(takeUntil(this.destroy$)).subscribe((val) => {
                if (val && this.isCalculationDone) {
                    this.istighFormValid = false;
                }
            });
        });

        this.globalEmittersService.toolsFormGroup.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            this.toolsFormGroup = res;
        });

        this.globalEmittersService.isCalculationHappen.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.hideAdvanceOptions();
            }
        });
        this.LoadCalculationSubscription = this.globalEmittersService.LoadCalculation.pipe(takeUntil(this.destroy$)).subscribe((data: boolean) => {
            if (data) {
                this.btnCalculateClicked();
                if (this.selectedTool) {
                    this.globalEmittersService.ManufactureName.next(this.selectedTool.manufacturer.name);
                    this.globalEmittersService.ToolSelectedId.next(this.selectedTool.id);
                    this.IsCalculationOutPutTabSelected = true;
                }
            }
        });

        this.globalEmittersService.updateStandardFlangeHeader.pipe(takeUntil(this.destroy$)).subscribe((res) => {
            if (res) {
                this.subHeaderData = this.setSubHeaderValues(true);
            } else if (res == false) {
                this.subHeaderData = this.setSubHeaderValues(false);
            }
        });

        this.globalEmittersService.tighteningProcedureForm.pipe(takeUntil(this.destroy$)).subscribe((form: UntypedFormGroup) => {
            if (form) {
                form.get('calcMethod')
                    .valueChanges.pipe(takeUntil(this.destroy$))
                    .subscribe((methodType: string) => {
                        this.stdFlangeInput.others.tighteningMethod =
                            methodType.toLowerCase() == 'tension' ? TighteningMethod.Tension : TighteningMethod.Torque;
                    });
            }
        });
    }

    setSubHeaderValues(isOverriddenFlange: boolean): SubHeaderData {
        if (isOverriddenFlange) {
            let headerData = new SubHeaderData();
            headerData.displayText = this.translocoService.translate('INFORMATE_HEADER.OVERRIDDEN_FLANGE');
            headerData.disableActions = true;
            headerData.defaultImageSrc = '../../../../../assets/media/logos/custom-black-button.png';
            headerData.mouseOverImageSrc = '../../../../../assets/media/logos/custom-yellow-button.png';
            return headerData;
        } else if (isOverriddenFlange == false) {
            let headerData = new SubHeaderData();
            headerData.displayText = this.translocoService.translate('HOME_PAGE.HEADER.INFORMATE_DROPDOWN.LINK.STANDARD_FLANGE');
            headerData.disableActions = true;
            headerData.defaultImageSrc = '../../../../../../assets/media/logos/standard-black.png';
            headerData.mouseOverImageSrc = '../../../../../../assets/media/logos/standard-yellow.png';
            return headerData;
        }
    }

    hideAdvanceOptions() {
        if (this.calculationResult?.output) {
            this.hideAdvanceOptionTab = true;
        }
        if (this.calculationResult?.output?.general?.warnings) {
            let res = this.calculationResult.output.general.warnings.some((w) => w.severity <= 1);
            if (res === true) {
                this.hideAdvanceOptionTab = false;
            }
        }
    }

    tighteningDataHandler(tighteningData: TighteningData) {
        if (tighteningData.isDataValid) {
            this.stdFlangeInput.others.tighteningMethod = tighteningData.tighteningMethod;
            this.stdFlangeInput.others.breakout = tighteningData.breakout;
            this.stdFlangeInput.others.percentageCover = tighteningData.percentageCover;
            this.stdFlangeInput.others.lubricantMode = tighteningData.lubricantMode;
            this.stdFlangeInput.recordId.lubricantId = tighteningData.lubricantId;
            this.stdFlangeInput.calculationOverrides.kFactor = tighteningData.kFactor;
            this.isTighteningInputValid = true;
            this.editpanel_1 = true;
            this.tighteningform = false;
            this.stdInputform = true;
            this.panel1.close();
            this.setValidity();
            this.istighFormValid = true;
        } else {
            this.isTighteningInputValid = false;
        }
        if (!this.editpanel_1) {
            this.panel2.open();
        }
    }

    StdDataHandler(stdInputData: StdInputData) {
        if (stdInputData.isDataValid) {
            this.stdFlangeInput.recordId.standardId = stdInputData.standardId;
            this.stdFlangeInput.recordId.pressureClassId = stdInputData.pressureClassId;
            this.stdFlangeInput.recordId.pipeSizeId = stdInputData.pipeSizeId;
            this.stdFlangeInput.recordId.flangeTypeId1 = stdInputData.flangeTypeId1;
            this.stdFlangeInput.recordId.flangeFacingTypeId = stdInputData.flangeFacingTypeId;
            this.stdFlangeInput.recordId.flangeMaterialId1 = stdInputData.flangeMaterialId1;
            this.stdFlangeInput.recordId.gasketId = stdInputData.gasketId;
            this.stdFlangeInput.recordId.boltMaterialId = stdInputData.boltMaterialId;

            this.stdFlangeInput.recordId.flangeTypeId2 = stdInputData.flangeTypeId2;
            this.stdFlangeInput.recordId.pipeScheduleId = stdInputData.pipeScheduleId;
            this.stdFlangeInput.recordId.additionalThicknessId = stdInputData.additionalThicknessId;

            this.stdFlangeInput.others.tighteningSpecification = stdInputData.tighteningSpecification;
            this.stdFlangeInput.others.tighteningSpecificationInput = stdInputData.tighteningSpecificationInput;
            this.stdFlangeInput.others.boltType = stdInputData.boltType;
            this.stdFlangeInput.recordId.washerDimensionId = stdInputData.washerThickness;
            this.stdFlangeInput.calculationOverrides.additionalThickness = stdInputData.additionalThickness;

            this.stdFlangeInput.recordId.boltDimensionId = stdInputData.boltDimensionId;
            this.stdFlangeInput.others.threadType = stdInputData.threadType;
            this.stdFlangeInput.others.boltQuantity = stdInputData.boltQuantity;
            this.stdFlangeInput.recordId.nutDimensionId = stdInputData.nutDimensionId;
            stdInputData?.isRedAreaBoltSelected
                ? (this.stdFlangeInput.calculationOverrides.minimumBoltDiameter = stdInputData?.minimumBoltDiameter)
                : this.stdFlangeInput?.calculationOverrides?.minimumBoltDiameter
                  ? (this.stdFlangeInput.calculationOverrides.minimumBoltDiameter = undefined)
                  : '';
            stdInputData?.isRedAreaBoltSelected
                ? (this.stdFlangeInput.dimensionOverrides.reducedAreaBolting = stdInputData?.minimumBoltDiameter)
                : this.stdFlangeInput?.dimensionOverrides?.reducedAreaBolting
                  ? (this.stdFlangeInput.dimensionOverrides.reducedAreaBolting = undefined)
                  : '';
            this.stdFlangeInput.calculationOverrides.recommendedGasketStress = stdInputData.recommendedGasketStress;
            this.stdFlangeInput.calculationOverrides.minimumGasketStress = stdInputData.minimumGasketStress;
            this.stdFlangeInput.calculationOverrides.maximumGasketStress = stdInputData.maximumGasketStress;
            this.stdFlangeInput.calculationOverrides.y = stdInputData.y;
            this.stdFlangeInput.calculationOverrides.m = stdInputData.m;
            this.stdFlangeInput.calculationOverrides.pAdditional = stdInputData.pAdditional;
            this.isStdInputValid = true;

            this.editpanel_2 = true;
            this.stdInputform = false;
            this.processform = true;
            this.panel2.close();
            this.setValidity();

            this.isStdFormValid = true;
        } else {
            this.isStdInputValid = false;
        }
        if (!this.editpanel_2) {
            this.panel3.open();
        }
    }

    processInfoDataHandler(processInfoData: ProcessInfoData) {
        if (processInfoData.isDataValid) {
            this.stdFlangeInput.calculationOverrides.operatingTemperature = processInfoData.operatingTemperature;
            this.stdFlangeInput.calculationOverrides.operatingPressure = processInfoData.operatingPressure;
            this.stdFlangeInput.calculationOverrides.testPressure = processInfoData.testPressure;
            this.isProcessInfoInputValid = true;
            this.editpanel_3 = true;
            this.processform = false;
            this.toolsform = true;
            this.panel3.close();
            this.setValidity();
            this.isProcessFormValid = true;
        } else {
            this.isProcessInfoInputValid = false;
        }

        if (!this.editpanel_3) {
            this.panel4.open();
        }
    }

    toolsDataHandler(nearestObstruction: string) {
        this.stdFlangeInput.calculationOverrides.distanceToNearestObstruction = nearestObstruction;
    }

    selectedToolDataHandler(selectedToolId: string) {
        this.calculationResult.output.tools.forEach((x) => (x.isSelected = false));
        this.calculationResult.output.tools.find((x) => x.id === selectedToolId).isSelected = true;
        this.selectedTool = this.calculationResult.output.tools.find((x) => x.id === selectedToolId);
        this.dataSvc.selectedToolId = selectedToolId;
        this.outputTabIndex = 1;
    }

    async invokeCalculate(inputGroup: InputGroup) {
        await this.iceapi
            .postCalculateStandardFlange(inputGroup)
            .toPromise()
            .then(
                (res) => {
                    if (res.success === true) {
                        this.calculationResult = res.response;
                        if (!this.editpanel_3) {
                            this.panel4.open();
                        }
                        this.editpanel_3 = true;
                        this.panel3.close();
                        this.tighteningform = false;
                        this.stdInputform = false;
                        this.processform = false;
                        if (res.response.calculationSucceeded) {
                            this.calculationResult = res.response;
                            this.globalEmittersService.isCalculationHappen.next(true); // * this is used for tools component to display conditional based warning
                            this.toolsData = this.calculationResult.output.tools;
                            this.stdFlangeInput.calculationOverrides.minimumBoltDiameter = undefined;
                            this.outputTabIndex = 0;
                            if (!this.toolsData.length) {
                                this.outputTabIndex = 1;
                            }
                            this.subHeaderData.disableActions = false;
                            if (this.IsCalculationOutPutTabSelected) {
                                this.outputTabIndex = 1;
                            }
                        } else {
                            this.globalEmittersService.isCalculationHappen.next(false); // * this is used for tools component to display conditional based warning
                        }
                        this.cd.markForCheck();
                    } else {
                        this.globalEmittersService.isCalculationHappen.next(false);
                        this.user_utility.errorModelPopup(res.message);
                    }
                },
                (err) => {
                    this.globalEmittersService.isCalculationHappen.next(false);
                    this.user_utility.errorModelPopup(err);
                }
            );
    }

    diagramDataHandler(diagramInfo: DiagramInfo) {
        this.diagramInfo.isEditable = this.standardInputForm?.get('enableOveride')?.value == true ? true : false;
        switch (diagramInfo.diagramType || diagramInfo.flangeTypeId) {
            case 'Flange':
                // this.diagramInfo=new DiagramDataModel;
                if (diagramInfo?.diagramId?.length || diagramInfo.flangeTypeId) {
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.flange = diagramInfo;
                } else {
                    this.diagramInfo.flange = null;
                }
                break;
            case 'Flange Facing':
                if (diagramInfo?.diagramId?.length || diagramInfo.flangeFacingTypeId) {
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.flangeFacing = diagramInfo;
                } else {
                    this.diagramInfo.flangeFacing = null;
                }
                break;
            case 'Gasket':
                if (diagramInfo?.diagramId?.length || diagramInfo.gasketTypeId) {
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.gasket = diagramInfo;
                } else {
                    this.diagramInfo.gasket = null;
                }
                break;
            case 'Bolt Setting':
                if (diagramInfo?.name) {
                    this.diagramInfo.isDiagramsAdded = true;
                    this.diagramInfo.boltSettingsName = diagramInfo.name;
                    this.diagramInfo.torqueSequenceName = undefined;
                } else {
                    this.diagramInfo.boltSettingsName = undefined;
                    this.diagramInfo.torqueSequenceName = undefined;
                    this.calculationResult ? (this.diagramInfo.isDiagramsAdded = true) : (this.diagramInfo.isDiagramsAdded = false);
                }
                break;
            case 'Torque Sequence':
                if (this.stdFlangeInput.others.tighteningMethod == TighteningMethod.Torque) {
                    if (diagramInfo.noOfBolts <= 0) {
                        // this.diagramInfo.isDiagramsAdded = true;
                        diagramInfo.noOfBolts = this.stdFlangeInput.others.boltQuantity;
                    }
                    if (diagramInfo.noOfBolts !== undefined && diagramInfo.noOfBolts !== null) {
                        this.diagramInfo.isDiagramsAdded = true;
                        this.diagramInfo.torqueSequenceName = diagramInfo.noOfBolts + 'Hole';
                    } else {
                        this.diagramInfo.torqueSequenceName = undefined;
                    }
                    this.diagramInfo.boltSettingsName = undefined;
                    this.globalEmittersService.torqueSequencename.next(this.diagramInfo.torqueSequenceName);
                }
                break;
            case 'Tool Diagram':
                this.diagramInfo.isDiagramsAdded = true;
                this.diagramInfo.tool = diagramInfo;
                break;
            case 'Tool Image':
                this.diagramInfo.isDiagramsAdded = true;
                this.diagramInfo.toolImage = diagramInfo;
                break;
        }
    }

    diagramControlDataHandler(controlData: ControlData) {
        switch (controlData.controlName) {
            case 'flangeBoltHoleDiameter':
                this.stdFlangeInput.dimensionOverrides.flangeBoltHoleDiameter = controlData.controlValue;
                break;
            case 'flangeHeight':
                this.stdFlangeInput.dimensionOverrides.flangeHeight = controlData.controlValue;
                break;
            case 'flangeHubDiameter':
                this.stdFlangeInput.dimensionOverrides.flangeHubDiameter = controlData.controlValue;
                break;
            case 'flangeNeckOD':
                this.stdFlangeInput.dimensionOverrides.flangeNeckOD = controlData.controlValue;
                break;
            case 'flangeOD':
                this.stdFlangeInput.dimensionOverrides.flangeOD = controlData.controlValue;
                break;
            case 'flangePCD':
                this.stdFlangeInput.dimensionOverrides.flangePCD = controlData.controlValue;
                break;
            case 'flangeThickness':
                this.stdFlangeInput.dimensionOverrides.flangeThickness = controlData.controlValue;
                break;
            case 'grooveDepth':
                this.stdFlangeInput.dimensionOverrides.grooveDepth = controlData.controlValue;
                break;
            case 'outerRFOD':
                this.stdFlangeInput.dimensionOverrides.outerRFOD = controlData.controlValue;
                break;
            case 'pitchDiameter':
                this.stdFlangeInput.dimensionOverrides.pitchDiameter = controlData.controlValue;
                break;
            case 'reducedAreaBolting':
                this.stdFlangeInput.dimensionOverrides.reducedAreaBolting = controlData.controlValue;
                break;
            case 'rFDepth':
                this.stdFlangeInput.dimensionOverrides.rFDepth = controlData.controlValue;
                break;
            case 'rFID':
                this.stdFlangeInput.dimensionOverrides.rFID = controlData.controlValue;
                break;
            case 'rFOD':
                this.stdFlangeInput.dimensionOverrides.rFOD = controlData.controlValue;
                break;
            case 'rFThickness':
                this.stdFlangeInput.dimensionOverrides.rFThickness = controlData.controlValue;
                break;
            case 'gasketHeight':
                this.stdFlangeInput.dimensionOverrides.gasketHeight = controlData.controlValue;
                break;
            case 'gasketID':
                this.stdFlangeInput.dimensionOverrides.gasketID = controlData.controlValue;
                break;
            case 'gasketOD':
                this.stdFlangeInput.dimensionOverrides.gasketOD = controlData.controlValue;
                break;
            case 'gasketPitchDiameter':
                this.stdFlangeInput.dimensionOverrides.gasketPitchDiameter = controlData.controlValue;
                break;
            case 'gasketRingID':
                this.stdFlangeInput.dimensionOverrides.gasketRingID = controlData.controlValue;
                break;
            case 'gasketRingOD':
                this.stdFlangeInput.dimensionOverrides.gasketRingOD = controlData.controlValue;
                break;
            case 'gasketWidth':
                this.stdFlangeInput.dimensionOverrides.gasketWidth = controlData.controlValue;
                break;
            case 'gasketDegrees':
                this.stdFlangeInput.dimensionOverrides.gasketDegrees = controlData.controlValue;
                break;
            case 'gasketThickness':
                this.stdFlangeInput.dimensionOverrides.gasketThickness = controlData.controlValue;
                break;
            case 'widthOfFlat':
                this.stdFlangeInput.dimensionOverrides.widthOfFlat = controlData.controlValue;
                break;
        }
    }

    isEditableDataHandler(isEdit: boolean) {
        this.stdFlangeInput.dimensionOverrides = isEdit ? new DimensionOverridesInput() : null;
        this.diagramInfo.isEditable = isEdit;
    }

    processInfoInputDataHandler(processInfo: ProcessInfoModel) {
        this.processInfoInput = processInfo;
    }

    btnCalculateClicked() {
        this.stdFlangeInput.others.tighteningMethod = <any>TighteningMethod[this.tighteningProcedureForm?.get('calcMethod')?.value];
        this.globalEmittersService.refreshWarnings.next(true);

        if (this.isInputValid || this.isRedirect == 'true') {
            this.ngxUiLoaderService.start();
            if (this.isOverriddenFlange) {
            }
            this.stdFlangeInput.calculationType = this.isOverriddenFlange ? CalculationType.OverriddenFlange : CalculationType.StandardFlange;
            // this.stdFlangeInput.calculationType = CalculationType.StandardFlange
            if (!this.stdFlangeInput.calculationOverrides.distanceToNearestObstruction) {
                this.stdFlangeInput.calculationOverrides.distanceToNearestObstruction = '1000 mm';
            }
            this.invokeCalculate(this.stdFlangeInput)
                .then(() => {
                    this.ngxUiLoaderService.stop();
                    this.iceapi.calculationRes.next(true);
                    this.isCalculationDone = true;
                    this.globalEmittersService.refreshTools.next(true);
                })
                .catch(() => {
                    this.ngxUiLoaderService.stop();
                });
        }
    }

    setValidity() {
        if (this.isTighteningInputValid && this.isStdInputValid && this.isProcessInfoInputValid) {
            this.isInputValid = true;
        } else {
            this.isInputValid = false;
        }
    }

    beginform() {
        this.isInitialFormLoad = false;
        this.tighteningform = true;
        this.stdInputform = false;
        this.processform = false;
        this.toolsform = false;
        this.renderer.addClass(this.beginbtn.nativeElement, 'active');
    }

    showPanel1() {
        if (this.editpanel_1 == true) this.tighteningform = true;
        this.stdInputform = false;
        this.processform = false;
        this.toolsform = false;
    }

    showPanel2() {
        if (this.tighteningProcedureForm.valid) {
            this.tighteningform = false;
            this.stdInputform = true;
            this.processform = false;
            this.toolsform = false;
        }
    }

    showPanel3() {
        if (this.standardInputForm.valid) {
            this.tighteningform = false;
            this.processform = true;
            this.toolsform = false;
        }
    }

    showPanel4() {
        if (this.processInfoForm.valid) {
            this.tighteningform = false;
            this.stdInputform = false;
            this.toolsform = true;
        }
    }

    showpanel() {
        this.showpaneltoggle = !this.showpaneltoggle;
    }

    showUnitpanel() {
        this.showPanelUnitToggle = !this.showPanelUnitToggle;
    }
    showPanel1And2() {
        this.tighteningform = true;
        this.stdInputform = true;
        this.processform = false;
        this.toolsform = false;
    }

    hidepanelclose() {
        this.showpaneltoggle = false;
    }

    hideUnitpanelClose() {
        this.showPanelUnitToggle = false;
    }

    overriddenFlangeHandler(event: boolean) {
        if (event) {
            this.isOverriddenFlange = true;
        } else if (event == false) {
            this.isOverriddenFlange = false;
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
